<template>
  <div>
    <div class="parent" :style="style">
      <v-card>
        <div class="parent-side">
          <v-card-title class="info-title">
            <div class="text-center">
              {{ reportCard.Title }}
            </div>
          </v-card-title>
          <div>
            <app-row title="امتیاز:" :value="reportCard.score" />
            <div style="padding: 0px 15px;margin: 0 !important;">
              <span class="rowTitle">عنوان: </span>
              <div class="rowDetail">
                {{ reportCard.FName }}
              </div>
            </div>
            <div style="padding: 0px 15px;margin-top: 10px !important;">
              <span class="rowTitle">شاخص رتبه بندی: </span>
              <div class="rowDetail">
                {{ reportCard.TotalTitle }}
              </div>
            </div>
            <div
              v-if="reportCard.Description"
              style="padding: 0px 15px;margin-top: 10px !important;"
            >
              <span class="rowTitle">توضیحات: </span>
              <div class="rowDetail">
                {{ reportCard.Description }}
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["reportCard"],
  components: {
    appRow: DetailRow,
  },
  created() {},
  data: () => ({
    show: false,
  }),
  methods: {},
  computed: {
    style() {
      var res = "";
      if (this.$store.getters.isMobile) {
        res = "width: 100%";
      } else {
        res = "width: calc(100% - 300px)";
      }
      return res;
    },
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px 15px 0px 0px !important;
  width: auto;
}

.v-card {
  display: flex !important;
}
.rotated {
  transform-origin: 113px 113px;
  width: 226px;
}
.parent-side {
  border-radius: 15px 15px 0px 15px !important;
  width: 100%;
}
.flex-card {
  display: flex;
  direction: column;
  justify-content: center;
  align-items: center;
}
#textWrap {
  line-break: anywhere;
  text-align: center;
  text-wrap: wrap;
  margin: auto;
}
.rowDetail {
  padding: 5px;
  margin: 5px;
  margin-right: 20px;
}
.rowTitle {
  padding: 10px;
  margin: 5px;
  font-size: 0.9rem;
  font-weight: 600;
}
</style>
